import React from 'react';
import './HumanTouch.sass';

import { ReactComponent as Arrow } from '../../Icons/arrow-light-right.svg';

interface Props {
	label: string;
	// eslint-disable-next-line react/require-default-props
	isExternal: boolean;
	hrefSource: string;
}

function HumanTouch({ label, isExternal, hrefSource }: Props) {
	return (
		<a
			href={hrefSource}
			target={`${isExternal ? '_blank' : '_self'}`}
			className="uikit-human-touch"
		>
			<span className="uikit-human-touch__inner">
				{label}
				<Arrow className="uikit-human-touch__arrow" />
			</span>
		</a>
	);
}

export default HumanTouch;
